import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import {
    subscribeToInStockMonitor,
    unsubscribeFromInStockMonitor,
} from '../Services/BftInStockMonitor.service';

const BftInStockMonitorButton = ({ articleNumber, monitored }) => {
    const [isMonitored, setIsMonitored] = useState(!!monitored);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleClick = async () => {
        setIsLoading(true);
        setHasError(false);
        try {
            if (isMonitored) {
                await unsubscribeFromInStockMonitor(articleNumber);
            } else {
                await subscribeToInStockMonitor(articleNumber);
            }
            setIsMonitored(!isMonitored);
        } catch (ex) {
            setHasError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="product-detail__in-stock-monitor">
            {isMonitored && (
                <p className="product-detail__in-stock-monitor-info" role="status">
                    {translate('bft.pdpinstockmonitorconfirmation')}
                </p>
            )}
            <button
                className="button product-detail__buy-button product-detail__in-stock-monitor-button"
                type="button"
                disabled={isLoading}
                onClick={handleClick}
            >
                {translate(
                    isMonitored
                        ? 'bft.pdpinstockmonitorremovebutton'
                        : 'bft.pdpinstockmonitorbutton'
                )}
            </button>
            {hasError && (
                <p className="product-detail__in-stock-monitor-error" role="alert">
                    {translate('bft.pdpinstockmonitorerror')}
                </p>
            )}
        </div>
    );
};

export default BftInStockMonitorButton;
